import consentApi, { ConsentLogsResponse, CreateConsentLogsParams } from "../../api/consent/consentApi";
import { useGetApi, useMutateApi } from "../hooks";

type UseGetConsentLogsParams = {
  enabled?: boolean;
  allResponse?: boolean;
  onSuccess?: (data: any) => void;
  onError?: (error: unknown) => void;
};

export const useGetConsentLogs = ({
  enabled = true,
  allResponse = false,
  onSuccess,
  onError,
}: UseGetConsentLogsParams = {}) =>
  useGetApi<ConsentLogsResponse>({
    fetch: () => consentApi.getConsentLogs(),
    key: ["consentApi.getConsentLogs"],
    enabled,
    allResponse,
    onSuccess,
    onError,
  });

type UseCreateConsentLogsParams = {
  onSuccess?: (data: any, variables: CreateConsentLogsParams) => void;
  onError?: (error: unknown) => void;
};

export const useCreateConsentLogs = ({
  onSuccess,
  onError,
}: UseCreateConsentLogsParams = {}) =>
  useMutateApi<ConsentLogsResponse, CreateConsentLogsParams>({
    fetch: (params) => consentApi.createConsentLogs(params),
    key: "consentApi.createConsentLogs",
    onSuccess,
    onError,
  });